import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/CountryCodeModal.css';
import 'react-calendar/dist/Calendar.css';

class CountryCodeModal extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            data: [],
            publishhasOpen: false,
            advertisementName: '',
            url: '',
            calenderone: new Date(),
            hourValue: '',
            minitValue: '',
            formDate: '',
            calendertwo: new Date(),
            hourValueone: '',
            minitValueone: '',
            toDate: '',
            showCalenderone: false,
            showCalendertwo: false,
            dropDownHour: false,
            dropDownminit: false,
            dropDownHourone: false,
            dropDownminitone: false,
            hours: [],
            minit: [],
            tohours: [],
            tominits: [],
            imageUploadLinkMobile: '',
            imageUploadLinkWeb: '',
            isUploadDisabled: false,
            isDeleteDisabled: true,
            errors: {},
            cal1: false,
            cal2: false
        }
    }
    render() {
        return (
            <div class="CountryCodedatamodalcss" >
                <div class="CountryCodedatamodalcssin">
                    <div class="CountryCodedivoutercss">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}
export default CountryCodeModal;
